import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-34775ffb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  key: 0,
  class: "button-container"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
const _hoisted_9 = {
  class: "dialog-footer"
};
import { listTenant, delTenant, addTenant, updateTenant, getTenantMenu, dataScope } from "@/api/system1/tenant";
import { menusOptions } from "@/api/system1/role";
import { ref, unref, reactive, onMounted, nextTick, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from 'element-plus';
import { weChatrequest } from '@/utils/request';
import JSEncrypt from 'jsencrypt';
export default {
  __name: 'index',
  setup(__props) {
    const form = ref(null);
    const form1 = ref(null);
    const store = useStore();
    const router = useRouter();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '租户管理';
    });
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    // 状态数据字典
    const statusOptions = ref([{
      dictValue: 1,
      dictLabel: "正常"
    }, {
      dictValue: 0,
      dictLabel: "停用"
    }]);
    const defaultProps = ref({
      children: "children",
      label: "label"
    });
    const statusOptions1 = ref([]);
    const statusOptions2 = ref([]);
    // 菜单列表
    const menuOptions = ref([]);
    const statusOptions3 = ref([{
      dictValue: 1,
      dictLabel: "是"
    }, {
      dictValue: 0,
      dictLabel: "否"
    }]);
    const state = reactive({
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      openLoading: false,
      // 非多个禁用
      multiple: true,
      // 租户表格数据
      roleList: [],
      // 弹出层标题
      title: "",
      formData: [{
        prop: "permKeywords",
        label: "菜单权限",
        placeholder: "请选择菜单权限",
        type: "elTree",
        nodeKey: 'value',
        props: defaultProps,
        isSelect: false,
        options: menuOptions,
        span: 24
      }],
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        keywords: ''
      },
      form1: {
        permKeywords: '',
        tenantId: null
      },
      // 表单参数
      form: {
        "tenantCode": "",
        "tenantName": "",
        "contactPerson": "",
        "contactPhone": "",
        "contactEmail": "",
        "domain": "",
        "logoUrl": [],
        "status": 0,
        "expireTime": "",
        "maxUsers": 100,
        "maxDevices": 100,
        "mapCenterLongitude": 108.9915740,
        "mapCenterLatitude": 34.1430180,
        "mapZoomLevel": 16
      },
      rules1: {
        password: [{
          required: true,
          message: "新密码不能为空",
          trigger: "blur"
        }, {
          pattern: /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/,
          message: "密码必须包含字母、数字和英文特殊字符，长度为最少8位",
          trigger: "blur"
        }]
      },
      // 表单校验
      rules: {
        tenantCode: [{
          required: true,
          message: "租户编码不能为空",
          trigger: "blur"
        }],
        tenantName: [{
          required: true,
          message: "租户名称不能为空",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "租户状态不能为空",
          trigger: "change"
        }]
        // email: [
        //   {
        //     pattern: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
        //     message: "请输入正确的邮箱地址",
        //     trigger: "blur",
        //   },
        // ],
        // mobile: [
        //   {
        //     pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
        //     message: "请输入正确的手机号码",
        //     trigger: "blur",
        //   },
        // ],
      },
      saveLoading: false,
      saveLoading1: false,
      publicKey: '',
      searchFormData: [{
        prop: "tenantCode",
        label: "租户编码",
        placeholder: "租户编码",
        type: "text",
        isSelect: false,
        span: 4
      }, {
        prop: "tenantName",
        label: "租户名称",
        placeholder: "租户名称",
        type: "text",
        isSelect: false,
        span: 4
      }, {
        prop: "contactPerson",
        label: "联系人",
        placeholder: "联系人",
        type: "text",
        isSelect: false,
        span: 4
      }, {
        prop: "status",
        label: "状态",
        placeholder: "请选择状态",
        type: "list",
        isSelect: false,
        filterable: true,
        options: statusOptions,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ['tenant:add'],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => handleAdd(item)
      }, {
        buttonName: "删除",
        buttonStyle: "danger",
        hasPermi: ['tenant:delete'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => handleDelete(item),
        disabledHandle(row) {
          return state.multiple;
        }
      }],
      tableHeader: [{
        prop: "tenantName",
        label: "租户名称"
      }, {
        prop: "tenantCode",
        label: "租户编码"
      }, {
        prop: "contactPerson",
        label: "联系人"
      }, {
        prop: "contactPhone",
        label: "联系电话"
      }, {
        prop: "domain",
        label: "租户域名"
      }, {
        prop: "mapCenterLongitude",
        label: "中心经度"
      }, {
        prop: "mapCenterLatitude",
        label: "中心纬度"
      }, {
        prop: "mapZoomLevel",
        label: "缩放级别"
      }, {
        prop: "expireTime",
        label: "过期时间"
      }, {
        prop: "status",
        label: "状态",
        statusList: [{
          value: 1,
          label: "正常"
        }, {
          value: 0,
          label: "停用"
        }]
      }, {
        prop: "operation",
        label: "操作",
        width: "200px",
        fixed: "right",
        operation: [{
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: ['tenant:edit']
        }, {
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ['tenant:delete']
        }, {
          name: '分配权限',
          clickFun: row => handleDataScope(row),
          hasPermi: ['tenant:role'],
          hideHandle() {
            return userType != 3; //只有超管显示分配权限
          }
        }]
      }],
      form1Data: [{
        prop: "password",
        label: "新密码",
        placeholder: "请输入新密码",
        type: "text",
        isSelect: false,
        span: 24
      }],
      formScopeData: [{
        prop: "tenantCode",
        label: "租户编码",
        placeholder: "租户编码",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "tenantName",
        label: "租户名称",
        placeholder: "租户名称",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "contactPerson",
        label: "联系人",
        placeholder: "联系人",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "contactPhone",
        label: "联系电话",
        placeholder: "联系电话",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "contactEmail",
        label: "联系邮箱",
        placeholder: "联系邮箱",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "domain",
        label: "租户域名",
        placeholder: "租户域名",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "expireTime",
        label: "过期时间",
        placeholder: "过期时间",
        type: "datetime",
        isSelect: false,
        span: 24
      }, {
        prop: "maxUsers",
        label: "最大租户数",
        placeholder: "最大租户数",
        type: "textNum",
        isSelect: false,
        span: 24
      }, {
        prop: "maxDevices",
        label: "最大设备数",
        placeholder: "最大设备数",
        type: "textNum",
        isSelect: false,
        span: 24
      }, {
        prop: "status",
        label: "租户状态",
        placeholder: "请选择租户状态",
        type: "radio",
        isSelect: false,
        options: statusOptions,
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 24
      }, {
        prop: "mapCenterLongitude",
        label: "地图中心经度",
        placeholder: "请输入地图中心经度",
        type: "textNum",
        isSelect: false,
        min: -180,
        max: 180,
        precision: 7,
        step: 0.0000001,
        span: 24
      }, {
        prop: "mapCenterLatitude",
        label: "地图中心纬度",
        placeholder: "请输入地图中心纬度",
        type: "textNum",
        isSelect: false,
        min: -90,
        max: 90,
        precision: 7,
        step: 0.0000001,
        span: 24
      }, {
        prop: "mapZoomLevel",
        label: "地图缩放级别",
        placeholder: "请输入地图缩放级别",
        type: "textNum",
        isSelect: false,
        min: 1,
        max: 18,
        step: 1,
        precision: 0,
        span: 24
      }, {
        prop: "logoUrl",
        label: "租户Logo",
        placeholder: "请选择图片",
        type: "upload",
        span: 24
      }]
    });
    onMounted(() => {
      // 获取地区下拉
      weChatrequest({
        url: '/api/v1/sysArea/findTree',
        method: "get"
      }).then(res => {
        statusOptions2.value = [res.data];
      });
    });
    /** 查询租户列表 */
    const getList = function () {
      state.loading = true;
      listTenant(state.queryParams).then(response => {
        state.roleList = {
          rows: response.data.list,
          total: response.data.total
        };
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    };
    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      state.form = {
        "tenantCode": "",
        "tenantName": "",
        "contactPerson": "",
        "contactPhone": "",
        "contactEmail": "",
        "domain": "",
        "logoUrl": [],
        "status": 0,
        "expireTime": "",
        "maxUsers": 100,
        "maxDevices": 100,
        "mapCenterLongitude": 108.9915740,
        "mapCenterLatitude": 34.1430180,
        "mapZoomLevel": 16
      };
    };
    const cancel = function () {
      state.open = false;
    };

    // 表单重置
    const reset1 = function () {
      state.form1 = {
        code: '',
        dataScope: 0,
        id: '',
        name: '',
        sort: '',
        status: ''
      };
    };
    // 表单重置
    const reset = function () {
      state.form = {
        "tenantCode": "",
        "tenantName": "",
        "contactPerson": "",
        "contactPhone": "",
        "contactEmail": "",
        "domain": "",
        "logoUrl": [],
        "status": 0,
        "expireTime": "",
        "maxUsers": 100,
        "maxDevices": 100,
        "mapCenterLongitude": 108.9915740,
        "mapCenterLatitude": 34.1430180,
        "mapZoomLevel": 16
      };
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.dateRange = [];
      state.queryParams = {
        pageNum: 1,
        pageSize: 10,
        keywords: undefined
      };
      handleQuery();
    };
    // 多选框选中数据
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.id);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.openDataScope = true;
      state.title = "添加租户";
      reset();
    };
    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.title = "修改租户";
      state.form = {
        ...row
      };
      state.form.logoUrl = row.logoUrl && [row.logoUrl];
      state.openDataScope = true;
    };
    /** 查询菜单树结构 */
    const getMenuTreeselect = function () {
      menusOptions().then(response => {
        menuOptions.value = response.data;
        getTenantMenu(state.form1.tenantId).then(response => {
          state.form1.permKeywords = response.data;
          let arr = [];
          if (response.data.length > 0) {
            response.data.forEach(id => {
              const node = form1.value.menu[0].getNode(id);
              if (node && (!node.childNodes || !node.childNodes.length)) {
                arr.push(id);
              }
            });
            form1.value.menu[0].setCheckedKeys(arr);
          }
          state.openLoading = false;
        }).catch(error => {
          state.openLoading = false;
        });
      });
    };
    // 所有菜单节点数据
    const getMenuAllCheckedKeys = function () {
      // 目前被选中的菜单节点
      let checkedKeys = form1.value.menu[0].getHalfCheckedKeys();
      // 半选中的菜单节点
      let halfCheckedKeys = form1.value.menu[0].getCheckedKeys();
      console.log(halfCheckedKeys, 'halfCheckedKeys');
      checkedKeys.unshift.apply(checkedKeys, halfCheckedKeys);
      return checkedKeys;
    };
    /** 分配数据权限操作 */
    const handleDataScope = function (row) {
      state.open = true;
      state.openLoading = true, state.title = "分配数据权限";
      reset1();
      nextTick(() => {
        getMenuTreeselect();
        state.form1.tenantId = row.id;
      });
    };
    /** 分配权限提交按钮 */
    const submitForm = function () {
      if (state.form1.tenantId != undefined) {
        state.form1.permKeywords = getMenuAllCheckedKeys();
        dataScope(state.form1).then(response => {
          if (response.code == 0) {
            ElMessage.success("分配成功");
            state.open = false;
            getList();
          } else {
            ElMessage.error(response.msg);
          }
        });
      }
    };
    /** 修改/新增租户提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(form);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          console.log(params, 'params---');
          // if(params.logoUrl.length>0){
          params.logoUrl = params.logoUrl.toString();
          // }
          if (state.form.id) {
            updateTenant(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("修改成功");
                state.openDataScope = false;
                getList();
                // 租户编辑成功，更新用户信息，刷新系统store租户存储
                store.dispatch("common/GetInfo");
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            addTenant(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("新增成功");
                state.openDataScope = false;
                //新增后重置
                resetQuery();
                // 租户新增成功，更新用户信息，刷新系统store租户存储
                store.dispatch("common/GetInfo");
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      const tenantIds = row.id || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return delTenant(tenantIds);
      }).then(res => {
        getList();
        ElMessage.success("删除成功");
      }).catch(function () {});
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "zhihui-yonghujiance",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.roleList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.openDataScope = $event),
        size: "600px",
        title: state.title,
        "close-on-click-modal": false,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form",
          ref: form,
          form: state.form,
          formRules: state.rules,
          formData: state.formScopeData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => state.open = $event),
        size: "600px",
        title: "分配权限",
        "close-on-click-modal": false,
        onClose: cancel
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_withDirectives(_createVNode(_component_commonForm, {
          ref_key: "form1",
          ref: form1,
          form: state.form1,
          formRules: state.rules,
          formData: state.formData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"]), [[_directive_loading, state.openLoading]])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};